export const ADD_RIDER_TIP = "orderTip/ADD_RIDER_TIP";
export const REMOVE_RIDER_TIP = "orderTip/REMOVE_RIDER_TIP";
